import {
  AutocompleteInput,
  BooleanField,
  CreateButton,
  DataTable,
  DateField,
  EditButton,
  FilterButton,
  FunctionField,
  List,
  ReferenceField,
  ReferenceInput,
  SelectArrayInput,
  SelectField,
  TextField,
  TopToolbar,
} from "react-admin";
import {
  COMMUNITY_POST_STATUS_CHOICES,
  COMMUNITY_POST_TYPES_CHOICES,
} from "../utils/CommunityPostUtils";
import { COMMUNITY_POST_STATUS } from "../enums/CommunityPost";
import { validateRequired } from "../utils/Validations";
import TrueIcon from "@mui/icons-material/Done";
import FalseIcon from "@mui/icons-material/Clear";
import { COMMUNITY_POST_AUTHOR_CHOICES } from "../enums/CommunityPostAuthorTypes";
import { getCountries } from "../enums/Countries";
import { RESTAURANT_TYPES } from "../enums/RestaurantTypes";

const CommunityPostFilters = () => [
  <SelectArrayInput
    label="Estado"
    source="status"
    choices={COMMUNITY_POST_STATUS_CHOICES}
    validate={validateRequired}
    alwaysOn
  />,
  <SelectArrayInput
    label="Tipo"
    source="type"
    choices={COMMUNITY_POST_TYPES_CHOICES}
  />,
  <SelectArrayInput
    label="Autor"
    source="authorType"
    choices={COMMUNITY_POST_AUTHOR_CHOICES}
  />,
  <SelectArrayInput
    label="Países"
    source="countries"
    choices={getCountries()}
  />,
  <ReferenceInput
    source="restaurant"
    reference="restaurants"
    perPage={100}
    filter={{
      type: RESTAURANT_TYPES.REGULAR,
    }}
    label="Restaurante"
  >
    <AutocompleteInput
      filterToQuery={(searchText) => ({ name: searchText })}
      label="Restaurante"
      optionText="name"
    />
  </ReferenceInput>,
];

const CommunityPostListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
  </TopToolbar>
);

const CommunityPostList = () => (
  <List
    title="Publicaciones"
    exporter={false}
    actions={<CommunityPostListActions />}
    filters={CommunityPostFilters()}
    filterDefaultValues={{
      status: [COMMUNITY_POST_STATUS.PUBLISHED],
    }}
  >
    <DataTable rowClick="show" bulkActionButtons={false}>
      <DataTable.Col source="user" label="Usuario">
        <ReferenceField
          reference="users"
          source="user"
          label="Usuario"
          link={false}
        >
          <FunctionField
            source="firstName"
            render={(record) =>
              `${record?.firstName || ""} ${record?.lastName || ""}` || "-"
            }
          />
        </ReferenceField>
      </DataTable.Col>
      <DataTable.Col source="type" label="Tipo">
        <SelectField
          source="type"
          label="Tipo"
          choices={COMMUNITY_POST_TYPES_CHOICES}
        />
      </DataTable.Col>
      <DataTable.Col source="content" label="Contenido" />
      <DataTable.Col source="restaurant" label="Restaurante">
        <ReferenceField
          label="Restaurante"
          reference="restaurants"
          source="restaurant"
          link={false}
          emptyText="-"
        >
          <TextField source="name" label="Nombre" />
        </ReferenceField>
      </DataTable.Col>
      <DataTable.Col source="createdAt" label="Fecha">
        <DateField source="createdAt" label="Fecha" showTime />
      </DataTable.Col>
      <DataTable.Col source="pinned" label="Fijado">
        <BooleanField source="pinned" label="Fijado" />
      </DataTable.Col>
      <DataTable.Col source="status" label="Publicado">
        <FunctionField
          label="Publicado"
          source="status"
          render={(record) =>
            record.status === COMMUNITY_POST_STATUS.PUBLISHED ? (
              <TrueIcon fontSize="small" />
            ) : (
              <FalseIcon fontSize="small" />
            )
          }
        />
      </DataTable.Col>
      <DataTable.Col>
        <EditButton />
      </DataTable.Col>
    </DataTable>
  </List>
);

export default CommunityPostList;
